<script setup lang="ts">
import Error from '@/components/Error.vue';
</script>

<template>
  <error
    :icon="'mdi-link-off'"
    :title="'Page Not Found'"
    :message="'We could not find the page you were looking for. Please confirm if the url you provided is correct and try again.'" />
</template>
